module.exports = __webpack_public_path__ + "img/FR10206.a6a9a823.svg";